import { InjectionToken } from '@angular/core';

export const VIDEO_PLAYER_DATA = new InjectionToken<{}>('VIDEO_PLAYER_DATA');
